import { useState, useRef } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { rssFeedListActionsEnum } from 'modules/posts/enums';
import { fetchRssFeedList, fetchEditRssFeedSubmission } from 'modules/posts/actions';
import RssFeedComponent from 'modules/posts/components/RssFeedComponent';

// ###############################################################
// <------------------------ Constants -------------------------->
// ###############################################################
// ###############################################################
// <---------------------- End Constants ------------------------>
// ###############################################################
const RssFeedContainer = () => {
  // ###############################################################
  // <------------------------- Globals --------------------------->
  // ###############################################################
  const dispatch = useDispatch();
  const navigate = useNavigate();

  // const companyProfileKey = sessionStorage.getItem('companyProfileKeyAuthCookie');
  // ###############################################################
  // <----------------------- End Globals ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useState --------------------------->
  // ###############################################################
  const [showCopiedTextOverlay, setShowCopiedTextOverlay] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const [isPreviewFilePopupOpen, setIsPreviewFilePopupOpen] = useState(false);
  const [previewFileData, setPreviewFileData] = useState({});
  const [isActionPopupOpen, setIsActionPopupOpen] = useState(false);
  const [isActionPopupLoading, setIsActionPopupLoading] = useState(false);
  const [actionPopupStatus, setActionPopupStatus] = useState({});
  const [actionPopupTarget, setActionPopupTarget] = useState('');
  // ###############################################################
  // <---------------------- End useState ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ useEffect -------------------------->
  // ###############################################################
  // ###############################################################
  // <---------------------- End useEffect ------------------------>
  // ###############################################################
  // ###############################################################
  // <--------------------- rest of hooks ------------------------->
  // ###############################################################
  const searchBarInputTimeout = useRef(null);
  // ###############################################################
  // <-------------------- End rest of hooks ---------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Logic ---------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Logic -------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Actions --------------------------->
  // ###############################################################
  // eslint-disable-next-line no-unused-vars
  const submitSearchQuery = reset => {
    // setSelectedPageFilter(1);
    // const body = {
    //   ...ordersApiCallParams,
    // };
    // if (searchQuery) body.searchTerm = searchQuery;
    // if (reset) delete body.searchTerm;
    // setOrdersApiCallParams(body);
    // dispatch(fetchAllOrders(body));
  };

  const reloadRssFeedPage = () => {
    const body = {
      data: {
        companyKey: sessionStorage.getItem('companyProfileKeyAuthCookie'),
      },
    };

    dispatch(fetchRssFeedList(body));
  };

  const actionPopupConfirmBtnCallback = shouldReloadOrderDetails => {
    setIsActionPopupOpen(false);
    setIsActionPopupLoading(false);
    setActionPopupStatus({});
    setActionPopupTarget('');

    if (shouldReloadOrderDetails) reloadRssFeedPage();
  };
  // ###############################################################
  // <----------------------- End Actions ------------------------->
  // ###############################################################
  // ###############################################################
  // <----------------------- UI Handlers ------------------------->
  // ###############################################################
  const handleTextToCopyToClipboardClick = textToCopy => {
    navigator.clipboard.writeText(textToCopy);
    setShowCopiedTextOverlay(true);

    setTimeout(() => {
      setShowCopiedTextOverlay(false);
    }, 1000);
  };

  const handleAddRssFeedBtnClick = () => {
    navigate('/addRssFeed');
  };

  const handleSearchBarInputChange = event => {
    const { value } = event.target;
    const searchQueryMinLength = 3;

    if (value.length > 30) return;
    setSearchQuery(value);

    if (searchBarInputTimeout.current) clearTimeout(searchBarInputTimeout.current);

    if (value && value.length >= searchQueryMinLength) {
      searchBarInputTimeout.current = setTimeout(() => {
        clearTimeout(searchBarInputTimeout.current);

        submitSearchQuery();
      }, 300);
    }
    // this condition checks if we are deleteing letters from search query and we reached
    // 2 characters, then we need to clear search query filter
    else if (searchQuery.length >= searchQueryMinLength && value.length < searchQueryMinLength)
      submitSearchQuery(true);
  };

  const handlePreviewFileClick = (openPopup, fileType, fileUrl) => {
    if (openPopup) {
      setPreviewFileData({ type: fileType, url: fileUrl });
      setIsPreviewFilePopupOpen(true);
    } else setIsPreviewFilePopupOpen(false);
  };

  const handleActionBtnClick = (channelKey, status) => {
    setIsActionPopupOpen(true);
    setActionPopupStatus(status);
    setActionPopupTarget(channelKey);
  };

  const handleActionPopupConfirmBtnClick = () => {
    setIsActionPopupLoading(true);

    const body = {
      data: {
        channelKey: actionPopupTarget,
        companyKey: sessionStorage.getItem('companyProfileKeyAuthCookie'),
      },
      actionPopupCallbackAction: actionPopupConfirmBtnCallback,
    };

    if (actionPopupStatus.key === rssFeedListActionsEnum.disable)
      body.data.isDisabled = actionPopupStatus.value;
    else body.data.forceOpenGraphData = actionPopupStatus.value;

    dispatch(fetchEditRssFeedSubmission(body));
  };

  const handleActionPopupDismissBtnClick = () => {
    setIsActionPopupOpen(false);
    setActionPopupStatus({});
    setActionPopupTarget('');
  };
  // ###############################################################
  // <--------------------- End UI Handlers ----------------------->
  // ###############################################################
  // ###############################################################
  // <-------------------------- Render --------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------ End Render ------------------------->
  // ###############################################################
  // ###############################################################
  // <------------------------- Return UI ------------------------->
  // ###############################################################
  return (
    <RssFeedComponent
      showCopiedTextOverlay={showCopiedTextOverlay}
      searchQuery={searchQuery}
      isPreviewFilePopupOpen={isPreviewFilePopupOpen}
      previewFileData={previewFileData}
      isActionPopupOpen={isActionPopupOpen}
      isActionPopupLoading={isActionPopupLoading}
      actionPopupStatus={actionPopupStatus}
      actionPopupTarget={actionPopupTarget}
      handleTextToCopyToClipboardClick={handleTextToCopyToClipboardClick}
      handleAddRssFeedBtnClick={handleAddRssFeedBtnClick}
      handleSearchBarInputChange={handleSearchBarInputChange}
      handlePreviewFileClick={handlePreviewFileClick}
      handleActionBtnClick={handleActionBtnClick}
      handleActionPopupConfirmBtnClick={handleActionPopupConfirmBtnClick}
      handleActionPopupDismissBtnClick={handleActionPopupDismissBtnClick}
    />
  );
  // ###############################################################
  // <----------------------- End Return UI ----------------------->
  // ###############################################################
};

RssFeedContainer.propTypes = {
  rssFeedListApiCallBody: PropTypes.shape({
    current: PropTypes.shape({}),
  }).isRequired,
};

RssFeedContainer.defaultProps = {};

export default RssFeedContainer;
